import { LocationStrategy } from '@angular/common'
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http'
import { APP_INITIALIZER, ApplicationConfig, isDevMode } from '@angular/core'
import { provideAnimations } from '@angular/platform-browser/animations'
import { provideToastr } from 'ngx-toastr'
import { ErrorInterceptor } from '../../../../src/app/interceptors/error.interceptor'
import { MockLocationStrategy } from '@angular/common/testing'
import { routes } from '../../../../src/app/app.routes'
import { provideRouter } from '@angular/router'
import { AuthInterceptor } from '../../../../src/app/interceptors/auth.interceptor'
import { CommonApiParamsInterceptor } from '../../../../src/app/interceptors/common-api-params.interceptor'
import { TranslocoHttpLoader } from './transloco-component-loader'
import { provideTransloco } from '@jsverse/transloco'
import { appInitializer } from '../../../../src/app/app-initializer'
import { StatisticsService } from '../../../../src/app/services/statistics.service'
import { NavigationService } from '../../../../src/app/services/navigation.service'

export const appConfig: ApplicationConfig = {
   providers: [
      provideRouter(routes),
      provideHttpClient(withInterceptorsFromDi()),
      { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
      { provide: HTTP_INTERCEPTORS, useClass: CommonApiParamsInterceptor, multi: true },
      { provide: LocationStrategy, useClass: MockLocationStrategy },
      provideAnimations(),
      provideToastr({ positionClass: 'toast-position', closeButton: true, preventDuplicates: true, progressBar: true, timeOut: 7000 }),
      provideTransloco({
         config: {
            availableLangs: [
               'ar',  // Arabic
               'ca',  // Catalan
               'cs',  // Czech
               'cy',  // Welsh
               'da',  // Danish
               'de',  // German
               'en',  // English
               'es',  // Spanish
               'el',  // Greek
               'eu',  // Basque
               'fi',  // Finnish
               'fr',  // French
               'ga',  // Irish
               'gl',  // Galician
               'haw',  // Hawaiian
               'he',  // Hebrew
               'hu',  // Hungarian
               'hi',  // Hindi
               'is',  // Icelandic
               'it',  // Italian
               'la',  // Latin
               'ja',  // Japanese
               'ko',  // Korean
               'lt',  // Lithuanian
               'mi',  // Maori
               'ms',  // Malay
               'nb',  // Norwegian Bokmal
               'nn',  // Norwegian Nynorsk
               'no',  // Norwegian
               'nl',  // Dutch
               'pl',  // Polish
               'pt',  // Portuguese
               'ru',  // Russian
               'sv',  // Swedish
               'th',  // Thai
               'tr',  // Turkish
               'uk',  // Ukrainian
               'zh-tw',  // Chinese Traditional
               'zh',  // Chinese Simplified
            ],
            defaultLang: 'en',
            // Remove this option if your application doesn't support changing language in runtime.
            reRenderOnLangChange: true,
            prodMode: !isDevMode(),
         },
         loader: TranslocoHttpLoader
      }),
      {
         provide: APP_INITIALIZER,
         useFactory: appInitializer,
         deps: [StatisticsService, NavigationService]
      }
   ]
}
